const IconHide = (): JSX.Element => {
  return (
    <>
      <path
        d="M21 12C21 13.2 16.97 18 12 18C7.03 18 3 13.2 3 12C3 10.8 7.03 6 12 6C16.97 6 21 10.8 21 12Z"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12Z"
        stroke="black"
        strokeWidth="2"
      />
      <line
        x1="4.2"
        y1="19.9064"
        x2="19.7563"
        y2="4.35"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </>
  );
};

export default IconHide;
